import { Route, Switch } from 'react-router-dom'

import { PATH_LOGIN, PATH_RESET_PASSWORD, PATH_SET_PASSWORD, PATH_SIGNUP, PATH_SIGNUP_GOOGLE } from '@/constants'

import { Login } from './Login'
import { ResetPassword } from './ResetPassword'
import { SetPassword } from './SetPassword'
import { Signup } from './Signup'
import { SignupGoogle } from './SignupGoogle'

export const AuthenticationContainer = () => {
    return (
        <Switch>
            <Route path={PATH_LOGIN} component={Login} />
            <Route path={PATH_SIGNUP_GOOGLE} component={SignupGoogle} />
            <Route path={PATH_SIGNUP} component={Signup} />
            <Route path={PATH_RESET_PASSWORD} component={ResetPassword} />
            <Route path={PATH_SET_PASSWORD} component={SetPassword} />
            <Login />
        </Switch>
    )
}
